import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const FinishesDecorations = () => {
  // State
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeOption, setActiveOption] = useState(null);
  const [activeNestedOption, setActiveNestedOption] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Data
  const finishes_decorations = {
    name: "Interior",
    subcategories: {
      indoor_lighting: {
        name: "Interior",
        images: ["/assets/outdoorceiling/basin.webp"],
        products: [



          {
            name: "Tour",
            image: "/assets/outdoorceiling/tour.webp",
            use: "Indoor ceiling/wall lighting",
            details: "Energy-efficient LED fixture for interior spaces",
            price: "$29.99"
          },
          {
            name: "Baton",
            image: "/assets/outdoorceiling/baton.webp",
            use: "Indoor ceiling/wall lighting",
            details: "Energy-efficient LED fixture for interior spaces",
            price: "$29.99"
          },
          {
            name: "Skylum",
            image: "/assets/outdoorceiling/Skylum.webp",
            use: "Indoor ceiling/wall lighting",
            details: "Energy-efficient LED fixture for interior spaces",
            price: "$29.99"
          },
        ]
      },
      exterior: { name: "Exterior", images: [], products: [] },
      decorative_profiles: {
        name: "Technical and Decorative Profiles",
        options: {
          architectural: {
            name: "Decorative Listels",
            images: ["/assets/productimages/listels.jpg"],
            products: [
              {
                name: "Decorative Listels",
                image: "/assets/productimages/listels.jpg",
                use: "Architectural detailing",
                details: "2m length, polyurethane material",
                price: "",
              },
            ],
          },
          protection: {
            name: "Corner and Edge Protection",
            images: ["/assets/productimages/cornerprotection.jpg"],
            products: [
              {
                name: "Corner Bead",
                image: "/assets/productimages/cornerprotection.jpg",
                use: "Surface protection",
                details: "3m length, metal reinforced",
                price: "",
              },
            ],
          },
          skirting: {
            name: "Skirtings",
            images: ["/assets/productimages/skirting.webp"],
            products: [
              {
                name: "MDF Skirting Board",
                image: "/assets/productimages/skirting.webp",
                use: "Wall-floor transitions",
                details: "70mm height, primed white",
                price: "",
              },
            ],
          },
          flooring: {
            name: "Flooring Separations",
            images: ["/assets/productimages/flooroperation.jpeg"],
            products: [
              {
                name: "Floor Transition Strip",
                image: "/assets/productimages/flooroperation.jpeg",
                use: "Floor transitions",
                details: "Brushed aluminum, 2m length",
                price: "",
              },
            ],
          },
          stair: {
            name: "Stair Nosing",
            images: ["/assets/productimages/storenosing.jpeg"],
            products: [
              {
                name: "Anti-Slip Stair Nosing",
                image: "/assets/productimages/storenosing.jpeg",
                use: "Stair safety",
                details: "Anodized aluminum with grit insert",
                price: "",
              },
            ],
          },
          sanitary: { name: "Sanitary and Health Establishment", images: [], products: [] },
          facades: { name: "Facades and Terraces", images: [], products: [] },
        },
      },
      expansion_joints: {
        name: "Expansion Joints",
        options: {
          movement: {
            name: "Movement Joint Profiles",
            images: ["/assets/productimages/extensionjoins.jpeg"],
            products: [
              {
                name: "Expansion Joint Profile",
                image: "/assets/productimages/extensionjoins.jpeg",
                use: "Structural movement solutions",
                details: "20mm width, aluminum construction",
                price: "",
              },
            ],
          },
          structural: {
            name: "Structural Joints",
            images: ["/assets/productimages/buildingjoins.jpeg"],
            products: [
              {
                name: "Concrete Construction Joint",
                image: "/assets/productimages/buildingjoins.jpeg",
                use: "Building component connections",
                details: "Heavy-duty PVC formulation",
                price: "",
              },
            ],
          },
          cover_plates: { name: "Cover Plates", images: [], products: [] },
          fire_protection: {
            name: "Fire Barrier Systems",
            images: ["/assets/productimages/firebarrier.jpeg"],
            products: [
              {
                name: "Fire-Rated Joint System",
                image: "/assets/productimages/firebarrier.jpeg",
                use: "Fire protection",
                details: "2-hour fire rating, 30mm width",
                price: "",
              },
            ],
          },
          retracting: {
            name: "Retracting Joints",
            images: ["/assets/productimages/retractingjoints.jpeg"],
            products: [
              {
                name: "Seismic Joint Cover",
                image: "/assets/productimages/retractingjoints.jpeg",
                use: "Structural movement solutions",
                details: "50mm movement capacity",
                price: "",
              },
            ],
          },
        },
      },

      // accessibility_safety: {
      //   name: "Universal Accessibility and Safety",
      //   options: {
      //     podotactile: { name: "Podotactile System of Universal Accessibility", images: [], products: [] },
      //     non_slip: { name: "Non-slip Solution", images: [], products: [] },
      //     height_solutions: {
      //       name: "Solutions for Height",
      //       options: {
      //         photoluminescent: { name: "Photoluminescent Solutions", images: [], products: [] },
      //       },
      //     },
      //   },
      // },
      air_circulation: {
        name: "Air Circulation",
        options: {
          fans: {
            name: "Fans and Extractors",
            images: ["/assets/productimages/fans.jpg"],
            products: [
              {
                name: "Industrial Extractor Fan",
                image: "/assets/exhaustfans/fan1.png",
                use: "Air circulation systems",
                details: "High-capacity ventilation fan",
                price: "$149.99"
              },
              {
                name: "Axial fan REST D100 mesh back valve ERA",
                image: "/assets/exhaustfans/fan2.png",
                use: "Ventilation systems",
                details: "High-efficiency axial fan with back-draught valve",
                price: "$129.99"
              },
              {
                name: "Axial fan WIND D100 back-draught valve",
                image: "/assets/exhaustfans/fan3.png",
                use: "Ventilation systems",
                details: "Compact axial fan with back-draught valve for improved airflow",
                price: "$139.99"
              },
              {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan4.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              },
              {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan5.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              }, {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan6.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              },
              {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan7.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              }, {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan8.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              }, {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan9.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              },

              {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan10.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              }, {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan11.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              }, {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan12.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              },
              {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan13.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              }, {
                name: "Axial fan WIND D120 back-draught valve",
                image: "/assets/exhaustfans/fan14.png",
                use: "Ventilation systems",
                details: "Larger axial fan with D120 back-draught valve for high efficiency",
                price: "$159.99"
              },
            ]
          }
        }
      },
    },
  };

  // Handlers
  const handleSubcategoryClick = (key) => {
    setActiveSubcategory(key);
    setActiveOption(null);
    setActiveNestedOption(null);
  };

  const handleOptionClick = (key) => {
    setActiveOption(key);
    setActiveNestedOption(null);
  };

  const handleNestedOptionClick = (key) => {
    setActiveNestedOption(key);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => setSelectedProduct(null);

  // Render
  const renderSubcategories = () => (
    <div className="mb-3">
      <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
      <div className="flex flex-wrap gap-2">
        {Object.entries(finishes_decorations.subcategories).map(([key, sub]) => (
          <button
            key={key}
            onClick={() => handleSubcategoryClick(key)}
            className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
              ? "bg-blue-500 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
          >
            {sub.name}
          </button>
        ))}
      </div>
    </div>
  );

  const renderOptions = () => {
    if (!activeSubcategory) return null;
    const sub = finishes_decorations.subcategories[activeSubcategory];
    if (!sub.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(sub.options).map(([key, opt]) => (
            <button
              key={key}
              onClick={() => handleOptionClick(key)}
              className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                ? "bg-green-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {opt.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderNestedOptions = () => {
    if (!activeSubcategory || !activeOption) return null;
    const opt = finishes_decorations.subcategories[activeSubcategory].options[activeOption];
    if (!opt.options) return null;

    return (
      <div className="mb-3">
        <h2 className="text-lg font-semibold mb-3">More Options</h2>
        <div className="flex flex-wrap gap-2">
          {Object.entries(opt.options).map(([key, nested]) => (
            <button
              key={key}
              onClick={() => handleNestedOptionClick(key)}
              className={`px-3 py-1 rounded-full text-sm ${activeNestedOption === key
                ? "bg-purple-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {nested.name}
            </button>
          ))}
        </div>
      </div>
    );
  };

  const renderProducts = () => {
    let products = [];

    if (activeSubcategory && activeOption && activeNestedOption) {
      products =
        finishes_decorations.subcategories[activeSubcategory].options[activeOption].options[
          activeNestedOption
        ].products || [];
    } else if (activeSubcategory && activeOption) {
      products = finishes_decorations.subcategories[activeSubcategory].options[activeOption].products || [];
    } else if (activeSubcategory) {
      products = finishes_decorations.subcategories[activeSubcategory].products || [];
    }

    if (!products.length) {
      return <div className="text-center py-10 text-gray-500">No products available</div>;
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p, idx) => (
          <div
            key={idx}
            className="border rounded-lg shadow hover:shadow-lg cursor-pointer"
            onClick={() => handleProductClick(p)}
          >
            <img src={p.image} alt={p.name} className="w-full h-48 object-cover" />
            <div className="p-4">
              <h3 className="font-semibold text-lg">{p.name}</h3>
              <p className="text-gray-600">{p.use}</p>
              {/* <p className="text-blue-600 font-bold">{p.price}</p> */}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderModal = () =>
    selectedProduct && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg max-w-lg w-full overflow-hidden">
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="text-xl font-bold">{selectedProduct.name}</h2>
            <button onClick={closeModal}>&times;</button>
          </div>
          <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-64 object-cover" />
          <div className="p-4 space-y-2">
            <p>
              <strong>Uses:</strong> {selectedProduct.use}
            </p>
            <p>
              <strong>Details:</strong> {selectedProduct.details}
            </p>

          </div>
          <div className="p-4 flex justify-end border-t">
            <button
              onClick={closeModal}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );

  return (
    <>
      <ProductsNavRow />
      <div className="container mx-auto px-4 py-2">
        <h1 className="text-3xl font-bold mb-3">{finishes_decorations.name}</h1>
        {renderSubcategories()}
        {renderOptions()}
        {renderNestedOptions()}
        {renderProducts()}
        {renderModal()}
      </div>
    </>
  );
};

export default FinishesDecorations;
